 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","account":"account","box":"box","box-edit~box-quiz~classroom~interim-box~placement-tests~review-placement-test-result~student-placeme~acdc1984":"box-edit~box-quiz~classroom~interim-box~placement-tests~review-placement-test-result~student-placeme~acdc1984","box-edit":"box-edit","box-quiz~interim-box~placement-tests~review-placement-test-result":"box-quiz~interim-box~placement-tests~review-placement-test-result","box-quiz":"box-quiz","interim-box":"interim-box","placement-tests~review-placement-test-result":"placement-tests~review-placement-test-result","placement-tests":"placement-tests","review-placement-test-result":"review-placement-test-result","classroom~my-classrooms":"classroom~my-classrooms","classroom":"classroom","student-placementtest-history":"student-placementtest-history","student-quiz-history":"student-quiz-history","my-classrooms":"my-classrooms","edit-password":"edit-password","edit-profile":"edit-profile","forget-password":"forget-password","home":"home","invite-placement-test":"invite-placement-test","login":"login","my-boxes":"my-boxes","my-sprkr":"my-sprkr","password-reset":"password-reset","register":"register","registered":"registered","student-practice-history":"student-practice-history","verify-email":"verify-email"}[chunkId]||chunkId) + "." + {"404":"78831836","account":"e9b36598","box":"de3dfb55","box-edit~box-quiz~classroom~interim-box~placement-tests~review-placement-test-result~student-placeme~acdc1984":"f5adbc95","box-edit":"e844bcc3","box-quiz~interim-box~placement-tests~review-placement-test-result":"2e4f3a99","box-quiz":"4c4667c8","interim-box":"d3bda925","placement-tests~review-placement-test-result":"0de1d313","placement-tests":"7b642e4d","review-placement-test-result":"e8d56f5c","classroom~my-classrooms":"f8497ad7","classroom":"56097827","student-placementtest-history":"0d736670","student-quiz-history":"d6d14575","my-classrooms":"27820874","edit-password":"076fb461","edit-profile":"b7ba1e2a","forget-password":"e43809a8","home":"d0da7433","invite-placement-test":"58b58235","login":"efc323a5","my-boxes":"a1ddb2b2","my-sprkr":"b07bc616","password-reset":"432a3c74","register":"2a1a7f9f","registered":"48b1759e","student-practice-history":"80278ec7","verify-email":"b06cd509"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"account":1,"box":1,"box-edit":1,"box-quiz":1,"interim-box":1,"placement-tests~review-placement-test-result":1,"placement-tests":1,"review-placement-test-result":1,"classroom~my-classrooms":1,"classroom":1,"student-placementtest-history":1,"student-quiz-history":1,"my-classrooms":1,"edit-password":1,"edit-profile":1,"home":1,"invite-placement-test":1,"login":1,"my-boxes":1,"my-sprkr":1,"register":1,"registered":1,"student-practice-history":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","account":"account","box":"box","box-edit~box-quiz~classroom~interim-box~placement-tests~review-placement-test-result~student-placeme~acdc1984":"box-edit~box-quiz~classroom~interim-box~placement-tests~review-placement-test-result~student-placeme~acdc1984","box-edit":"box-edit","box-quiz~interim-box~placement-tests~review-placement-test-result":"box-quiz~interim-box~placement-tests~review-placement-test-result","box-quiz":"box-quiz","interim-box":"interim-box","placement-tests~review-placement-test-result":"placement-tests~review-placement-test-result","placement-tests":"placement-tests","review-placement-test-result":"review-placement-test-result","classroom~my-classrooms":"classroom~my-classrooms","classroom":"classroom","student-placementtest-history":"student-placementtest-history","student-quiz-history":"student-quiz-history","my-classrooms":"my-classrooms","edit-password":"edit-password","edit-profile":"edit-profile","forget-password":"forget-password","home":"home","invite-placement-test":"invite-placement-test","login":"login","my-boxes":"my-boxes","my-sprkr":"my-sprkr","password-reset":"password-reset","register":"register","registered":"registered","student-practice-history":"student-practice-history","verify-email":"verify-email"}[chunkId]||chunkId) + "." + {"404":"541b1d1c","account":"53f346f1","box":"89290389","box-edit~box-quiz~classroom~interim-box~placement-tests~review-placement-test-result~student-placeme~acdc1984":"31d6cfe0","box-edit":"5bc95b81","box-quiz~interim-box~placement-tests~review-placement-test-result":"31d6cfe0","box-quiz":"3ae92cd2","interim-box":"f47a2b05","placement-tests~review-placement-test-result":"2025b226","placement-tests":"c1a6028c","review-placement-test-result":"f1aa5b65","classroom~my-classrooms":"c2789c11","classroom":"c0676e9c","student-placementtest-history":"bdeaab51","student-quiz-history":"e271b12e","my-classrooms":"eece4cec","edit-password":"3d937e66","edit-profile":"0bcfcfcf","forget-password":"31d6cfe0","home":"eaaaf9b9","invite-placement-test":"b66ce46f","login":"d1731b50","my-boxes":"eaaaf9b9","my-sprkr":"5b85f278","password-reset":"31d6cfe0","register":"e498014f","registered":"08f0bc90","student-practice-history":"2652fde1","verify-email":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
